import { Injectable } from '@angular/core';
import { BasicAlfrescoAuthService } from '@alfresco/adf-core';
import { HttpHeaders } from '@angular/common/http';

// TODO: Remove WkBasicAlfrescoAuthService and related workaround once @alfresco/adf-core is upgraded to version 8.x.x or higher.
@Injectable({ providedIn: 'root' })
export class WkBasicAlfrescoAuthService extends BasicAlfrescoAuthService {
  getAuthHeaders(requestUrl: string, header: HttpHeaders): HttpHeaders {
    if (localStorage.getItem('isSsoUser') === 'true') {
      return header;
    }
    return super.getAuthHeaders(requestUrl, header);
  }
}
